import { render, staticRenderFns } from "./AtomTag.vue?vue&type=template&id=419983db&scoped=true&"
import script from "./AtomTag.vue?vue&type=script&lang=js&"
export * from "./AtomTag.vue?vue&type=script&lang=js&"
import style0 from "./AtomTag.vue?vue&type=style&index=0&id=419983db&prod&lang=postcss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "419983db",
  null
  
)

export default component.exports